import React from "react";
import { useNavigate } from "react-router-dom";
import assetsManager from "../assets/assetsmanager/assestsmanager";

const ProfileMenu = ({ setProfileMenu }) => {
  //hooks
  const navigate = useNavigate();

  //handle logout click
  const handleLogout = () => {
    localStorage.removeItem("adminAuthToken");
    setProfileMenu(false);
    navigate("/admin");
  };

  return (
    <div className="profile-menu z-[100] rounded-[6px] w-[6rem] bg-white p-2 flex flex-col gap-2 shadow-md">
      <button
        onClick={handleLogout}
        className="rounded-[3px] flex items-center gap-2 p-1 w-full justify-between px-4 text-[14px]"
      >
        <img
          className="h-[14px] fill-black"
          src={assetsManager.logout}
          alt=""
        />
        Logout
      </button>
    </div>
  );
};

export default ProfileMenu;
